const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC41ODU4IDEyTDcuMjkyODkgNC43MDcxMkw4LjcwNzExIDMuMjkyOTFMMTcuNDE0MiAxMkw4LjcwNzExIDIwLjcwNzFMNy4yOTI4OSAxOS4yOTI5TDE0LjU4NTggMTJaIi8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=arrow_right-642c4a95.mjs.map
